export const environment = {
  production: false,
  ecomBffBasePath: '/api/bff',
  storefrontBaseUrl: 'https://ecom-dev.uniretail.app',
  /** Origin serving product images/videos; preconnected up-front for LCP. */
  mediaOrigin: 'https://dev.uniretail.app',
  defaultLang: 'vi',
};
